import {
  LayoutAuth, LayoutDefault, LayoutReports, LayoutChildren
} from '@/components/layouts';
import store from '@/store';

export const publicRoute = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '*',
    component: () => import('@/views/error/NotFound.vue'),
  },
  {
    path: '/login',
    redirect: '/auth/login',
  },
  {
    path: '/auth',
    component: LayoutAuth,
    meta: {
      title: 'Login',
    },
    redirect: '/auth/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: {
          title: 'Login',
        },
        component: () => import('@/views/Login.vue'),
      },
      {
        path: 'logout',
        name: 'logout',
        component: {
          beforeRouteEnter() {
            store.dispatch('auth/logout', null, { root: true });
          },
        },
      },
    ],
  },

  {
    path: '/404',
    name: '404',
    meta: {
      title: 'Not Found',
    },
    component: () => import('@/views/error/NotFound.vue'),
  },

  {
    path: '/500',
    name: '500',
    meta: {
      title: 'Server Error',
    },
    component: () => import('@/views/error/Error.vue'),
  },
  {
    path: '/murphy-find',
    name: 'murphy-find',
    component: () => import('@/views/MurphyFindView.vue'),
    meta: {
      title: 'murphy',
      validate: (user) => {
        return user.attributes.murphyfind === 'true';
      },
    },
  },
];

export const protectedRoute = [
  {
    path: '/admin',
    name: 'admin',
    component: LayoutDefault,
    meta: {
      title: 'home',
      group: 'apps',
      icon: '',
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: 'home',
          group: 'apps',
          icon: '$home',
          admin: true,
        },
        component: () => import('@/views/Home.vue'),
      },
      {
        path: '/administracion',
        name: 'administracion',
        component: LayoutChildren,
        redirect: '/users',
        meta: {
          title: 'administracion',
          group: 'apps',
          icon: 'mdi-account-cog',
        },
        children: [
          {
            path: '/users',
            name: 'users',
            meta: {
              title: 'users',
              group: 'apps',
              icon: '$user',
              admin: true,
            },
            component: () => import('@/views/Users.vue'),
          },
          {
            path: '/profiles',
            name: 'profiles',
            meta: {
              title: 'profiles',
              group: 'apps',
              icon: '$group',
              admin: true,
            },
            component: () => import('@/views/Profiles.vue'),
          },
          {
            path: '/groups',
            name: 'groups',
            meta: {
              title: 'groups',
              group: 'apps',
              icon: '$group',
              validate: (user) => {
                return user.attributes.permission_groups;
              },
            },
            component: () => import('@/views/Groups.vue'),
          },
        ],
      },
      {
        path: '/video',
        name: 'video',
        component: LayoutChildren,
        redirect: '/cameras',
        meta: {
          title: 'video',
          group: 'apps',
          icon: 'mdi-cctv',
        },
        children: [
          {
            path: '/cameras',
            name: 'cameras',
            meta: {
              title: 'cameras',
              group: 'apps',
              icon: '$camera',
              validate: (user) => {
                return user.attributes.permission_cameras;
              },
            },
            component: () => import('@/views/Cameras.vue'),
          },
          {
            path: '/video-servers',
            name: 'video-servers',
            meta: {
              title: 'video-servers',
              group: 'apps',
              icon: 'mdi-server',
              iconColor: 'black',
            },
            component: () => import('@/views/VideoServers.vue'),
          },
        ],
      },
      {
        path: '/bus',
        name: 'bus',
        meta: {
          title: 'bus',
          group: 'apps',
          icon: '$bus',
          validate: (user) => {
            return user.attributes.permission_bus;
          },
        },
        component: () => import('@/views/Bus.vue'),
      },
      {
        path: '/geofences',
        name: 'geofences',
        meta: {
          title: 'geofences',
          group: 'apps',
          icon: '$geofence',
          validate: (user) => {
            return user.attributes.permission_geofences;
          },
        },
        component: () => import('@/views/Geofences.vue'),
      },
      {
        path: '/mando-unico',
        name: 'mando-unico',
        component: LayoutChildren,
        meta: {
          title: 'mando-unico',
          group: 'apps',
          icon: '$geofence',
        },
        children: [
          {
            path: '/mando-unico/geofences',
            name: 'mando-unico-geofences',
            meta: {
              title: 'mando-unico-geofences',
              group: 'apps',
              icon: '$geofence',
            },
            component: () => import('@/views/MandoUnicoGeofences.vue'),
          },
          {
            path: '/mando-unico/region',
            name: 'mando-unico-region',
            meta: {
              title: 'mando-unico-region',
              group: 'apps',
              icon: '$geofence',
            },
            component: () => import('@/views/MandoUnicoRegion.vue'),
          },
          {
            path: '/mando-unico/sector',
            name: 'mando-unico-sector',
            meta: {
              title: 'mando-unico-sector',
              group: 'apps',
              icon: '$geofence',
            },
            component: () => import('@/views/MandoUnicoSector.vue'),
          },
          {
            path: '/mando-unico/cuadrante',
            name: 'mando-unico-cuadrante',
            meta: {
              title: 'mando-unico-cuadrante',
              group: 'apps',
              icon: '$geofence',
            },
            component: () => import('@/views/MandoUnicoCuadrante.vue'),
          },
        ],
      },
      // {
      //   path: '/incidents',
      //   name: 'incidents',
      //   meta: {
      //     title: 'incidents',
      //     group: 'apps',
      //     icon: 'mdi-alert',
      //   },
      //   component: () => import('@/views/Incidents.vue'),
      // },
      {
        path: '/analiticos',
        name: 'analiticos',
        component: LayoutChildren,
        redirect: '/lpr',
        meta: {
          title: 'analiticos',
          group: 'apps',
          icon: '$lpr',
        },
        children: [
          {
            path: '/lpr',
            name: 'lpr',
            meta: {
              title: 'lpr',
              group: 'apps',
              icon: '$lpr',
              validate: (user) => {
                return user.attributes.permission_lpr;
              },
            },
            component: () => import('@/views/LPR.vue'),
          },
          {
            path: '/lpr-categories',
            name: 'lpr-categories',
            meta: {
              title: 'lpr-categories',
              group: 'apps',
              icon: 'mdi-tag-multiple',
              validate: (user) => {
                return user.attributes.permission_lpr;
              },
            },
            component: () => import('@/views/LPRCategories.vue'),
          },
        ],
      },
      {
        path: '/listas-negras',
        name: 'listas-negras',
        component: LayoutChildren,
        redirect: '/lista-negra',
        meta: {
          title: 'listas-negras',
          group: 'apps',
          icon: 'mdi-car-off',
          validate: (user) => user.attributes.permission_blacklist,
        },
        children: [
          {
            path: '/lista-negra',
            name: 'lista-negra',
            meta: {
              title: 'lista-negra',
              group: 'apps',
              icon: 'mdi-format-list-bulleted',
              validate: (user) => user.attributes.permission_blacklist,
            },
            component: () => import('@/views/BlacklistEntries.vue'),
          },
          {
            path: '/lista-negra-categorias',
            name: 'lista-negra-categorias',
            meta: {
              title: 'lista-negra-categorias',
              group: 'apps',
              icon: 'mdi-tag-multiple',
              validate: (user) => user.attributes.permission_blacklist,
            },
            component: () => import('@/views/BlacklistCategories.vue'),
          },
          {
            path: '/lista-negra-webhooks',
            name: 'lista-negra-webhooks',
            meta: {
              title: 'lista-negra-webhooks',
              group: 'apps',
              icon: 'mdi-webhook',
              validate: (user) => user.attributes.permission_blacklist,
            },
            component: () => import('@/views/BlacklistWebhookSubscribers.vue'),
          },
        ],
      },
      {
        path: '/botones-panico',
        name: 'botones',
        component: LayoutChildren,
        redirect: '/sensor',
        meta: {
          title: 'botones',
          group: 'apps',
          icon: '$sensor',
        },
        children: [
          {
            path: '/sensor',
            name: 'sensor',
            meta: {
              title: 'sensor',
              group: 'apps',
              icon: '$sensor',
              validate: (user) => {
                return user.attributes.permission_sensor;
              },
            },
            component: () => import('@/views/Sensor.vue'),
          },
          {
            path: '/sensor-categories',
            name: 'sensor-categories',
            meta: {
              title: 'sensor-categories',
              group: 'apps',
              icon: 'mdi-tag-multiple',
            },
            component: () => import('@/views/SensorCategories.vue'),
          },
        ],
      },
      {
        path: '/dispositivos',
        name: 'dispositivos',
        component: LayoutChildren,
        redirect: '/devices',
        meta: {
          title: 'dispositivos',
          group: 'apps',
          icon: 'mdi-car-multiple',
        },
        children: [
          {
            path: '/devices',
            name: 'devices',
            meta: {
              title: 'devices',
              group: 'apps',
              icon: '$device',
              validate: (user) => {
                return user.attributes.permission_devices;
              },
            },
            component: () => import('@/views/Devices.vue'),
          },
          {
            path: '/deviceCategories',
            name: 'deviceCategories',
            meta: {
              title: 'deviceCategories',
              group: 'apps',
              icon: 'mdi-tag-multiple',
            },
            component: () => import('../views/DeviceCategories.vue'),
          },
          {
            path: '/drivers',
            name: 'drivers',
            meta: {
              title: 'drivers',
              group: 'apps',
              icon: '$driver',
            },
            component: () => import('@/views/Drivers.vue'),
          },
          {
            path: '/fuelPrice',
            name: 'fuelPrice',
            meta: {
              title: 'fuelPrice',
              group: 'apps',
              icon: 'mdi-fuel',
            },
            component: () => import('@/views/FuelPrice.vue'),
          },
        ],
      },
      // {
      //   path: '/drivers',
      //   name: 'drivers',
      //   meta: {
      //     title: 'drivers',
      //     group: 'apps',
      //     icon: '$driver',
      //   },
      //   component: () => import('@/views/Drivers.vue'),
      // },
      // {
      //   path: '/maintenance',
      //   name: 'maintenance',
      //   meta: {
      //     title: 'maintenance',
      //     group: 'apps',
      //     icon: 'mdi-hammer-wrench',
      //   },
      //   component: () => import('@/views/Maintenance.vue'),
      // },
      {
        path: '/routes',
        name: 'routes',
        meta: {
          title: 'routes',
          group: 'apps',
          icon: 'mdi-map-marker-path',
        },
        component: () => import('@/views/Routes.vue'),
      },
      {
        path: '/reports',
        name: 'reports',
        meta: {
          title: 'reports',
          group: 'apps',
          icon: 'mdi-file-chart',
        },
        redirect: '/reports/devices',
      },
      {
        path: '/incident-categories',
        name: 'incident-categories',
        meta: {
          title: 'incident-categories',
          group: 'apps',
          icon: 'mdi-format-list-bulleted-type',
        },
        component: () => import('@/views/IncidentCategories.vue'),
      },

    ],
  },
  {
    path: '/reports',
    component: LayoutReports,
    meta: {
      title: 'home',
      group: 'apps',
      icon: '',
    },
    redirect: '/home',
    children: [
      {
        // Entrada de menú "Mapa" del AppDrawer (renderiza vía :to=item.path).
        // Redirige al destino canónico /map (V2). Sin `name` para no chocar
        // con la ruta /map (que ya usa name: 'map').
        path: '/maps',
        meta: {
          title: 'map',
          group: 'apps',
          icon: 'mdi-map',
        },
        redirect: '/map',
      },
      {
        path: '/reports/users',
        name: 'users-reports',
        meta: {
          title: 'users',
          group: 'apps',
          icon: 'mdi-account-group-outline',
          admin: true,
        },
        component: () => import('@/views/reports/UsersReports.vue'),
      },
      {
        path: '/reports/cameras',
        name: 'cameras-reports',
        meta: {
          title: 'cameras',
          group: 'apps',
          icon: '$camera-white',
        },
        component: () => import('@/views/reports/CamerasReports.vue'),
      },
      // {
      //   path: '/reports/bus',
      //   name: 'bus-reports',
      //   meta: {
      //     title: 'bus',
      //     group: 'apps',
      //     icon: '$bus-white',
      //   },
      //   component: () => import('@/views/reports/BusesReports.vue'),
      // },
      // {
      //   path: '/reports/lpr',
      //   name: 'lpr-reports',
      //   meta: {
      //     title: 'lpr',
      //     group: 'apps',
      //     icon: '$lpr-white',
      //   },
      //   component: () => import('@/views/reports/LprsReports.vue'),
      // },
      // {
      //   path: '/reports/sensor',
      //   name: 'sensor-reports',
      //   meta: {
      //     title: 'sensor',
      //     group: 'apps',
      //     icon: '$sensor-white',
      //   },
      //   component: () => import('@/views/reports/SensorsReports.vue'),
      // },
      {
        path: '/reports/devices',
        name: 'devices-reports',
        meta: {
          title: 'devices',
          group: 'apps',
          icon: '$device-white',
        },
        component: () => import('@/views/reports/DevicesReports.vue'),
      },
      {
        path: '/reports/incidents',
        name: 'incidents-reports',
        meta: {
          title: 'incidents',
          group: 'apps',
          icon: 'mdi-alert-outline',
        },
        component: () => import('@/views/reports/IncidentsReports.vue'),
      },
      {
        path: '/reports/sos',
        name: 'sos-reports',
        meta: {
          title: 'kalan-sos',
          group: 'apps',
          icon: 'mdi-cellphone-information',
        },
        component: () => import('@/views/reports/SosReports.vue'),
      },
    ],
  },
  {
    // Mapa legacy (OpenLayers CDN). Congelado: solo accesible por URL
    // directa (no aparece en menú ni en navegación programática). Se
    // mantiene como fallback de emergencia mientras se valida V2 en
    // producción; se eliminará en una fase posterior junto con
    // src/views/Map.vue y src/components/map/.
    path: '/map-legacy',
    name: 'map-legacy',
    component: () => import('@/views/Map.vue'),
    meta: {
      title: 'map-legacy',
      group: 'map',
      icon: 'mdi-maps',
      hiddenInMenu: true,
    },
  },
  {
    // Mapa canónico (MapLibre + entity-configs). Antes vivía en /map-v2.
    path: '/map',
    name: 'map',
    component: () => import('@/views/MapV2.vue'),
    meta: { title: 'map', group: 'map', icon: 'mdi-map' },
  },
  {
    // Retro-compat: bookmarks y enlaces guardados al path anterior siguen
    // funcionando redirigiendo al nuevo destino canónico.
    path: '/map-v2',
    redirect: '/map',
  },
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/stream',
    name: 'stream',
    component: () => import('@/views/Stream.vue'),
  }
];

export const protectedRoutesWithoutLayout = [
  {
    path: '/analytics/monitor',
    name: 'analytics-monitor',
    meta: {
      title: 'analytics-monitor',
      group: 'apps',
      icon: '$lpr',
      // validate: (user) => user.attributes.permission_analytics_monitor,
    },
    component: () => import('@/views/AnalyticsMonitor.vue'),
  },
  {
    path: '/analytics/history',
    name: 'analytics-history',
    meta: {
      title: 'analytics-history',
      group: 'apps',
      icon: '$lpr',
      // validate: (user) => user.attributes.permission_analytics_monitor,
    },
    component: () => import('@/views/AnalyticsHistory.vue'),
  },
  {
    path: '/analytics/faces',
    name: 'analytics-faces',
    meta: {
      title: 'analytics-faces',
      group: 'apps',
      icon: 'mdi-face-recognition',
      validate: (user) => user.attributes.permission_face_search === 'true',
    },
    component: () => import('@/views/FaceSearch.vue'),
  },
  {
    path: '/analytics/intelli',
    name: 'analytics-intelli',
    meta: {
      title: 'analytics-intelli',
      group: 'apps',
      icon: 'mdi-auto-fix',
      validate: (user) => user.attributes.permission_ai_search === 'true',
    },
    component: () => import('@/views/AISearch.vue'),
  },
];
